import * as React from 'react';

const Bookmark24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.75 2.5c-.69 0-1.25.56-1.25 1.25v17.793l5.483-3.738a1.75 1.75 0 0 1 2.034 0l5.483 3.738V3.75c0-.69-.56-1.25-1.25-1.25zM4 3.75A2.75 2.75 0 0 1 6.75 1h10.5A2.75 2.75 0 0 1 20 3.75v18.28a1.25 1.25 0 0 1-1.977 1.017l-5.878-4.02a.25.25 0 0 0-.29 0l-5.878 4.02A1.25 1.25 0 0 1 4 22.028z"
  }
));
Bookmark24.Size = 24;
Bookmark24.Title = "Bookmark";

export { Bookmark24 as default };
